<app-user-header></app-user-header>
<div class="logged-out">
    <i class="fa fa-user-md"></i>
    You have been logged out
    <div class="login-again">
        <a href="{{loginUrl}}">Log in again?</a>
    </div>
</div>
